<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login3.svg"
                alt="login"
                class="lg:w-1/2 ml-12"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="mb-8">Login</h2>
                </div>
                <ValidationObserver ref="observer">
                  <div>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="username"
                    >
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        placeholder="Username"
                        v-model="email"
                        class="w-full mb-2 place-p-l"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="password"
                    >
                      <vs-input
                        icon-after="true"
                        icon="icon iconvisibility"
                        v-model="password"
                        type="password"
                        id="password"
                        placeholder="Password"
                        class="password mb-2 w-full mt-6 place-p-l"
                        :visiblePassword="true"
                        v-on:icon-click="visibilityHandling"
                        @keyup.enter="login"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>

                    <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                        >Remember Me</vs-checkbox
                      >
                      <router-link to="forgetPassword"
                        >Forgot Password?</router-link
                      >
                    </div>
                    <vs-button class="login_button" @click="login">
                      {{ $t("label.button.login") }}
                    </vs-button>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import { removeHeader, setBearerToken } from "../../http/index";
import { ValidationProvider, ValidationObserver } from "vee-validate";
let visiblePassword = false;
export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      hasVisiblePassword: false,
      email: "",
      password: "",
      checkbox_remember_me: true,
      message: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    visibilityHandling() {
      this.hasVisiblePassword = !this.hasVisiblePassword;
    },
    async login() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        const data = {
          username: this.email,
          password: this.password,
        };
        const user = await this.$store.dispatch("auth/signinAction", data);
        // await this.$store.dispatch("auth/setUser", user.data);

        sessionStorage.setItem("ngb:bearer_token", user.data.accessToken);
        // sessionStorage.setItem(
        //   "ngb:user_token",
        //   JSON.stringify(user.data.base64EncodedAuthenticationKey)
        // );
        // setAuthorizationHeader(user.data.base64EncodedAuthenticationKey);
        const now = Date.now();
        const tokenData = {
          refreshToken: user.data.refreshToken,
          accessToken_Expiry: user.data.accessToken_Expiry,
          refreshToken_Expiry: user.data.refreshToken_Expiry,
          tokenIssuedAt: now,
        };

        sessionStorage.setItem("tokenData", JSON.stringify(tokenData));
        sessionStorage.setItem("refreshTokenIssuedAt", now);
        setBearerToken(user.data.accessToken);
        await this.getUserDetail();
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something Went Wrong",
          type: "warning",
        });
      }
    },
    async getUserDetail() {
      try {
        const response = await this.$store.dispatch(
          "auth/getUserDetailsAction"
        );
        sessionStorage.setItem("ngb:user", JSON.stringify(response.data));
        this.$store.dispatch("auth/setUserDetail", response.data);
        this.$router.push("/dashboard");
      } catch (error) {
        removeHeader("Authorization");
        this.$swal({
          title: "Error",
          icon: "error",
          text: error,
          type: "warning",
        });
      }
    },
  },
  async mounted() {
    sessionStorage.clear();
    removeHeader("Authorization");

    const passwordField = document.querySelector(".password");
    const lockEl = `<i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-lock null icon-no-border"></i>`;
    const iel = document.createElement("i");
    iel.classList.add(
      "vs-icon",
      "notranslate",
      "icon-scale",
      "icon-inputx",
      "notranslate",
      "vs-input--icon",
      "feather",
      "icon",
      "icon-lock",
      "null",
      "icon-no-border"
    );
    // passwordField.firstElementChild.innerHTML =
    //   passwordField.firstElementChild.innerHTML + lockEl;
    passwordField.firstElementChild.append(iel);
    const passwordInput = document.getElementById("password");
    const icon = passwordField.querySelector(".vs-input--icon");
    icon.addEventListener("click", function () {
      if (visiblePassword) {
        passwordInput.type = "password";
        icon.textContent = "icon iconvisibility";
      } else {
        passwordInput.type = "text";
        icon.textContent = "icon iconvisibility_off";
      }
      visiblePassword = !visiblePassword;
    });
  },
};
</script>

<style lang="scss">
.vx-card__title {
  text-align: center;
}
.login_button {
  margin-left: 37%;
}
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
[dir="ltr"] .ml-12 {
  margin-left: 6rem !important;
}
#password {
  padding-left: 3rem !important;
}
.place-p-l .vs-input--placeholder.normal {
  padding-left: 3rem !important;
}
.vs-input--icon {
  padding-right: 1rem !important;
  margin-top: 2px !important;
}
.vs-input--input.normal ~ .vs-input--icon.feather {
  top: 7px !important;
}
.vs-input--placeholder {
  top: auto;
}
</style>
<style scoped>
::v-deep .vs-input--icon {
  top: 10px !important;
}
</style>
